import axios from 'axios';
import { api, headers } from '../../app/conf';
import { makeQuery } from '../../shared/helpers/commons';

export const getCompanies = (filters, token) =>
    axios({
        method: 'get',
        url: `${api}/companies?${makeQuery(filters)}`,
        headers: {
            ...headers,
            'X-Access-Token': token,
            persistResponse: true
        }
    });
